import { defineStore } from 'pinia'
import { useRouter } from 'vue-router'
import { getInfoByXjuTicket } from '@/api'
import * as process from 'process'
import getNativeInstance from '@/utils/JSBridge'
const router = useRouter()

export interface IAuthState {
	userInfo: any
	ticket: string
	isAuth: boolean
	code: string
	token: string
	openid: string
}

function loginToWx(ticket) {
	getNativeInstance().customInvoke({
		action: 'loginByCas',
		data: {
			ticket: ticket
		}
	})
	if (wx) {
		console.log('触发小程序回退，发送postmessage')
		wx.miniProgram.navigateBack()
	}
}

export const useAuthStore = defineStore({
	id: 'auth',
	state: () =>
		({
			userInfo: {},
			ticket: '',
			isAuth: false,
			code: '',
			openid: '',
			token: ''
		} as IAuthState),
	actions: {
		saveTicket(data: any) {
			this.$state.ticket = data
		},
		saveUserInfo(data: any) {
			this.$state.userInfo = data
		},
		setIsAuth(data: boolean) {
			this.$state.isAuth = data
		},
		setCode(code: string) {
			this.$state.code = code
		},
		setToken(token: string) {
			this.$state.token = token
		},
		setOpenid(openid: string) {
			this.$state.openid = openid
		},
		clearToken() {
			this.$state.token = ''
		},
		toLogin(url) {
			const address = `${url}?service=${encodeURIComponent(location.origin)}`
			console.log(address)
			console.log(import.meta.env.VITE_ENV)
			setTimeout(() => {
				if (window.UniAppJSBridge) {
					getNativeInstance().customInvoke({
						action: 'setAppStatusBar',
						data: {
							visible: true
						}
					})
				}
				if (import.meta.env.VITE_ENV === 'development') {
					console.log(address)
				} else {
					window.location.replace(address)
				}
			}, 1234)
		},
		async getUserInfo(ticket) {
			// if (ticket) {
			// 	if (window.UniAppJSBridge) {
			// 		loginToWx(ticket)
			// 	} else {
			// 		document.addEventListener('UniAppJSBridgeReady', function () {
			// 			loginToWx(ticket)
			// 		})
			// 	}
			// }
			try {
				const res = await getInfoByXjuTicket({ ticket, sourceUrl: window.location.origin })
				const resData = res.data || {}
				this.setToken(resData.xjuToken)
				this.saveUserInfo(resData.UserInfo)
				this.saveTicket(resData.ticket)
			} catch (e) {
				return Promise.reject(e)
			} finally {
				// 重定向去掉ticket
				// if (!navigator.userAgent.includes('xjuapp')) {
				// 	window.location.replace(window.location.origin)
				// }
			}
		},
		async logout() {
			this.setToken('')
			this.saveUserInfo({})
			this.saveTicket('')
			this.setOpenid('')
			this.$state.isAuth = false
			this.$state.code = ''
		}
	},
	// 开启数据缓存
	persist: {
		key: 'auth',
		storage: window.localStorage,
		// paths: ['name'],
		overwrite: true
	}
})
